import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ForgotPasswordSendEmailLink } from '../actions/forgot-password';
import * as fromForgot from '../reducers';

@Component({
  selector: 'spaq-wait-password-page',
  template: `
    <spaq-wait-password (onMailRequest)="sendConfirmationLink($event)"
                        [status]="success$ | async"
                        [form]="form$ | async"
                        [pending]="pending$ | async"></spaq-wait-password>
  `,
  styles: [],
})
export class WaitPasswordPageComponent implements OnInit {

  form$ = this.store.select(fromForgot.getForgotPasswordPageForm);
  pending$ = this.store.select(fromForgot.getForgotPasswordPagePending);
  success$ = this.store.select(fromForgot.getForgotPasswordPageEmailLinkSuccess);

  constructor(private store: Store<any>) {
  }

  ngOnInit() {
  }

  sendConfirmationLink($event) {
    return this.store.dispatch(new ForgotPasswordSendEmailLink($event));
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/containers/wait-password-page.component.ts